import "./style.scss";
import { useClickOutside } from "@hook";
import { useRef, useState } from "react";

const Default = ({ id, data = [], title = "", onChance, disable = false, city = false, error, setError = () => {}, isEmpty }) => {
    const [open, setOpen] = useState(false);

    const nodeRef = useRef();

    useClickOutside("id", nodeRef, () => setOpen(false));

    return (
        <div className={`select__ui  ${id}`} ref={nodeRef} key={id}>
            <div
                className={`select__ui-input ${isEmpty ? "select__ui-input_empty" : ""} ${disable ? "disable" : ""} ${error ? "error" : ""}`}
                onClick={
                    disable
                        ? () => {}
                        : () => {
                              setOpen(!open);
                              setError(false);
                          }
                }
            >
                <span>{title.length ? title : "Выберите город"}</span>
                <svg style={open ? { transform: "rotate(180deg) " } : {}} width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L7 7L13 1" stroke="#B1BAD4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
            <div className={`select__ui-list ${open ? "visible" : ""}`}>
                {id === "filial" ? <div className="select-list__desc">{`Адреса в г. ${city.city} `}</div> : null}
                <div className="block__scroll">
                    {data.map((m, idx) => (
                        <div
                            key={idx}
                            className="select-list__item"
                            onClick={() => {
                                onChance(id, m);
                                setOpen(!open);
                            }}
                        >
                            {m.city ? m.city : m.name ? m.name : m.text}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Default;
